import { useImmerAtom } from 'jotai-immer';
import {
    tableViewAtom,
    tableFiltersAtom,
    tableStatsAtom,
    splitOrderInvoicesDataAtom,
} from '../split_order_invoices_list_atoms';
import { SplitOrderInvoicesDataHook } from '../split_order_invoices_list_types';
import { useTableData } from '../../../../core/table/hooks/useTableData';

export const useSplitOrderInvoicesData = (): SplitOrderInvoicesDataHook => {
    const [view] = useImmerAtom(tableViewAtom);
    const [filters] = useImmerAtom(tableFiltersAtom);
    const [stats, setStats] = useImmerAtom(tableStatsAtom);
    const [data] = useImmerAtom(splitOrderInvoicesDataAtom);

    const { items } = useTableData({ view, filters, stats, data, setStats });

    return { items, rawDataSize: data.dataItems.length };
};
